function hideLowRatedYotpoWidgets() {

    const widgets = document.querySelectorAll('.yotpo-bottom-line-scroll-panel');

    if (!widgets.length) {
        setTimeout(hideLowRatedYotpoWidgets, 500);
        return;
    }

    widgets.forEach(function(widget) {

        const button = widget.querySelector('.yotpo-sr-bottom-line-button');
        if (!button) return;

        const match = button.getAttribute('aria-label')?.match(/^(\d+(\.\d+)?)/);
        if (!match) return;

        const rating = parseFloat(match[1]);

        if (rating < 3) {
            widget.style.display = 'none';
        }

    });

}

hideLowRatedYotpoWidgets();